import React, { useEffect, useRef } from 'react';
import postcodes from '../../dataSets/postcodes';

export default function PostcodeCityInputs({
  prefix,
  postCodeFieldName,
  cityFieldName,
  handleChange,
  formData,
  setFormData,
  loading = false,
  skipCityAutocompleteRef = null,
}) {
  const postcodeFieldValue = formData ? formData[`${prefix}_postcode`] : null;
  const isInitialized = useRef(false);

  useEffect(() => {
    if (loading) {
      isInitialized.current = false;
      return;
    }
    if (!isInitialized.current) {
      isInitialized.current = true;
      return;
    }
    if (skipCityAutocompleteRef?.current?.[prefix]) {
      skipCityAutocompleteRef.current[prefix] = false;
      return;
    }
    if (!formData || !prefix) return;

    let postcodeValue = postcodeFieldValue;
    if (postcodeValue && postcodeValue.length >= 4) {
      if (postcodeValue.length === 4) {
        postcodeValue = '0' + postcodeValue;
      }
    }

    if (postcodeValue && postcodes[postcodeValue]) {
      setFormData(prevFormData => ({
        ...prevFormData,
        [`${prefix}_city`]: postcodes[postcodeValue][0],
      }));
    } else {
      setFormData(prevFormData => ({
        ...prevFormData,
        [`${prefix}_city`]: '',
      }));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [postcodeFieldValue, prefix, setFormData, loading]);

  const handleBlurPostcode = e => {
    if (!formData || !prefix) return;
    if (e.target.value && e.target.value.length === 4) {
      setFormData(prevFormData => ({
        ...prevFormData,
        [`${prefix}_postcode`]: '0' + e.target.value,
      }));
    }
  };

  const handleBlurCity = e => {
    if (!formData || !prefix) return;
    if (e.target.value) {
      setFormData(prevFormData => ({
        ...prevFormData,
        [`${prefix}_city`]: e.target.value.toUpperCase(),
      }));
    }
  };

  return (
    <div className="horizontal-input-group">
      <label>CP :</label>
      <input
        type="text"
        name={postCodeFieldName}
        value={formData && prefix ? formData[`${prefix}_postcode`] || '' : ''}
        onChange={handleChange}
        onBlur={handleBlurPostcode}
        autoComplete="one-time-code"
      />
      <label className="supp-element">Ville :</label>
      <input
        type="text"
        name={cityFieldName}
        value={formData && prefix ? formData[`${prefix}_city`] || '' : ''}
        onChange={handleChange}
        onBlur={handleBlurCity}
        autoComplete="one-time-code"
      />
    </div>
  );
}
